// extracted by mini-css-extract-plugin
var _1 = "GiftingBlock-module__container___KxLyG";
var _2 = "GiftingBlock-module__content___gh7fA";
var _3 = "GiftingBlock-module__image___BkTHk";
var _4 = "GiftingBlock-module__imageContainer___dwEpP";
var _5 = "GiftingBlock-module__subText___UtPT1";
var _6 = "GiftingBlock-module__title___N2TJZ";
export { _1 as "container", _2 as "content", _3 as "image", _4 as "imageContainer", _5 as "subText", _6 as "title" }
